interface PartnerLogoBadgeProps {
  name: string;
  logoUrl?: string;
  size?: 'sm' | 'md' | 'lg' | 'xl' | '2xl';
  variant?: 'square' | 'circle';
}

export function PartnerLogoBadge({ 
  name, 
  logoUrl, 
  size = 'md',
  variant = 'square'
}: PartnerLogoBadgeProps) {
  const sizeClasses = {
    sm: 'h-12 w-12 text-xs',
    md: 'h-16 w-16 text-sm',
    lg: 'h-24 w-24 text-base',
    xl: 'h-32 w-32 text-lg',
    '2xl': 'h-40 w-40 text-xl',
  };

  const borderRadius = {
    square: '0.5rem',
    circle: '50%',
  };

  // Generate initials from name
  const getInitials = (name: string) => {
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .slice(0, 2);
  };

  return (
    <div
      className={`${sizeClasses[size]} flex items-center justify-center overflow-hidden border bg-white shadow-sm transition-all hover:shadow-md`}
      style={{
        borderRadius: borderRadius[variant],
        borderColor: 'rgba(0, 0, 0, 0.1)',
      }}
    >
      {logoUrl ? (
        <img 
          src={logoUrl} 
          alt={name}
          className="h-full w-full object-contain p-2"
        />
      ) : (
        <div
          className="flex h-full w-full items-center justify-center font-semibold"
          style={{
            backgroundColor: '#f0e8ff',
            color: '#3b0b86',
            fontFamily: 'var(--font-primary)',
          }}
        >
          {getInitials(name)}
        </div>
      )}
    </div>
  );
}